import {CollapsedState} from 'notebook/tables/collapse/reduceCollapsedTablesUI';
import {getStore} from 'redux-stores/Store';

export enum CollapsedTableActionType {
  TABLE_EDITABLE_INITIAL_COLLAPSED_STATE_SET = 'TABLE_EDITABLE_INITIAL_COLLAPSED_STATE_SET',
  TABLE_EDITABLE_COLLAPSED_STATE_TOGGLED = 'TABLE_EDITABLE_COLLAPSED_STATE_TOGGLED',
  TABLE_EDITABLE_COLLAPSED_STATE_SET = 'TABLE_EDITABLE_COLLAPSED_STATE_SET',
  INPUT_TABLE_INITIAL_COLLAPSED_STATE_SET = 'INPUT_TABLE_INITIAL_COLLAPSED_STATE_SET',
  INPUT_TABLE_COLLAPSED_STATE_TOGGLED = 'INPUT_TABLE_COLLAPSED_STATE_TOGGLED',
  OUTPUT_TABLE_INITIAL_COLLAPSED_STATE_SET = 'OUTPUT_TABLE_INITIAL_COLLAPSED_STATE_SET',
  OUTPUT_TABLE_COLLAPSED_STATE_TOGGLED = 'OUTPUT_TABLE_COLLAPSED_STATE_TOGGLED',
  REQUEST_ENTRY_TABLE_INITIAL_COLLAPSED_STATE_SET = 'REQUEST_ENTRY_TABLE_INITIAL_COLLAPSED_STATE_SET',
  REQUEST_ENTRY_TABLE_COLLAPSED_STATE_TOGGLED = 'REQUEST_ENTRY_TABLE_COLLAPSED_STATE_TOGGLED',
}

export interface TableEditableInitialCollapsedStateSetAction {
  type: CollapsedTableActionType.TABLE_EDITABLE_INITIAL_COLLAPSED_STATE_SET;
  tableCollapseId: string;
  collapsedState: CollapsedState;
}
export function tableEditableInitialCollapsedStateSet(
  tableCollapseId: string,
  collapsedState: CollapsedState
): TableEditableInitialCollapsedStateSetAction {
  return {
    type: CollapsedTableActionType.TABLE_EDITABLE_INITIAL_COLLAPSED_STATE_SET,
    tableCollapseId,
    collapsedState,
  };
}
export function setInitialCollapsedStateForTableEditable(
  tableCollapseId: string,
  collapsedState: CollapsedState
): void {
  getStore().dispatch(tableEditableInitialCollapsedStateSet(tableCollapseId, collapsedState));
}

export interface TableEditableCollapsedStateToggledAction {
  type: CollapsedTableActionType.TABLE_EDITABLE_COLLAPSED_STATE_TOGGLED;
  tableCollapseId: string;
  isCollapsedInitially: boolean;
}
export function tableEditableCollapsedStateToggled(
  tableCollapseId: string,
  isCollapsedInitially: boolean
): TableEditableCollapsedStateToggledAction {
  return {
    type: CollapsedTableActionType.TABLE_EDITABLE_COLLAPSED_STATE_TOGGLED,
    tableCollapseId,
    isCollapsedInitially,
  };
}
export function toggleTableEditableCollapsed(tableCollapseId: string, isCollapsedInitially: boolean): void {
  getStore().dispatch(tableEditableCollapsedStateToggled(tableCollapseId, isCollapsedInitially));
}

export interface TableEditableCollapsedStateSetAction {
  type: CollapsedTableActionType.TABLE_EDITABLE_COLLAPSED_STATE_SET;
  tableCollapseId: string;
  collapsedState: CollapsedState;
}
export function tableEditableCollapsedStateSet(
  tableCollapseId: string,
  collapsedState: CollapsedState
): TableEditableCollapsedStateSetAction {
  return {
    type: CollapsedTableActionType.TABLE_EDITABLE_COLLAPSED_STATE_SET,
    tableCollapseId,
    collapsedState,
  };
}
export function setCollapsedStateForTableEditable(
  tableCollapseId: string,
  collapsedState: CollapsedState
): void {
  getStore().dispatch(tableEditableCollapsedStateSet(tableCollapseId, collapsedState));
}

export interface InputTableInitialCollapsedStateSetAction {
  type: CollapsedTableActionType.INPUT_TABLE_INITIAL_COLLAPSED_STATE_SET;
  entryId: string;
  collapsedState: CollapsedState;
}
export function inputTableInitialCollapsedStateSet(
  entryId: string,
  collapsedState: CollapsedState
): InputTableInitialCollapsedStateSetAction {
  return {
    type: CollapsedTableActionType.INPUT_TABLE_INITIAL_COLLAPSED_STATE_SET,
    entryId,
    collapsedState,
  };
}
export function setInitialCollapsedStateForInputTable(entryId: string, collapsedState: CollapsedState): void {
  getStore().dispatch(inputTableInitialCollapsedStateSet(entryId, collapsedState));
}

export interface InputTableCollapsedStateToggledAction {
  type: CollapsedTableActionType.INPUT_TABLE_COLLAPSED_STATE_TOGGLED;
  entryId: string;
}
export function inputTableCollapsedStateToggled(entryId: string): InputTableCollapsedStateToggledAction {
  return {
    type: CollapsedTableActionType.INPUT_TABLE_COLLAPSED_STATE_TOGGLED,
    entryId,
  };
}
export function toggleInputTableCollapsed(entryId: string): void {
  getStore().dispatch(inputTableCollapsedStateToggled(entryId));
}

export interface OutputTableInitialCollapsedStateSetAction {
  type: CollapsedTableActionType.OUTPUT_TABLE_INITIAL_COLLAPSED_STATE_SET;
  entryId: string;
  collapsedState: CollapsedState;
}
export function outputTableInitialCollapsedStateSet(
  entryId: string,
  collapsedState: CollapsedState
): OutputTableInitialCollapsedStateSetAction {
  return {
    type: CollapsedTableActionType.OUTPUT_TABLE_INITIAL_COLLAPSED_STATE_SET,
    entryId,
    collapsedState,
  };
}
export function setInitialCollapsedStateForOutputTable(
  entryId: string,
  collapsedState: CollapsedState
): void {
  getStore().dispatch(outputTableInitialCollapsedStateSet(entryId, collapsedState));
}

export interface OutputTableCollapsedStateToggledAction {
  type: CollapsedTableActionType.OUTPUT_TABLE_COLLAPSED_STATE_TOGGLED;
  entryId: string;
}
export function outputTableCollapsedStateToggled(entryId: string): OutputTableCollapsedStateToggledAction {
  return {
    type: CollapsedTableActionType.OUTPUT_TABLE_COLLAPSED_STATE_TOGGLED,
    entryId,
  };
}
export function toggleOutputTableCollapsed(entryId: string): void {
  getStore().dispatch(outputTableCollapsedStateToggled(entryId));
}

export type CollapsedTableAction =
  | TableEditableInitialCollapsedStateSetAction
  | TableEditableCollapsedStateToggledAction
  | TableEditableCollapsedStateSetAction
  | InputTableInitialCollapsedStateSetAction
  | InputTableCollapsedStateToggledAction
  | OutputTableInitialCollapsedStateSetAction
  | OutputTableCollapsedStateToggledAction;
